import { MultiDeletePasswordEntry } from "./MultiDeletePasswordEntry";
import { MultiDeletePasswordLabelEntry } from "./MultiDeletePasswordLabelEntry";

export class MultiDeletePasswordRequest {
    entries: MultiDeletePasswordEntry[] = [];
}